export const CLASSNAME_BLOCKQUOTE = 'protonmail_quote';
